import { AppBrowse } from "@/utils/app-browses";
import { ISelectItem } from "winfakt-vue-components";

export enum BrowseExtraButtonLocation {
	MENU = 0,
	REPORTS = 1
}


export function getBrowseExtraButtonLocationAsSelectItems():ISelectItem<BrowseExtraButtonLocation>[]{
	let offset = Object.values(BrowseExtraButtonLocation).length / 2;
	return Object.values(BrowseExtraButtonLocation).filter(f=>typeof(f)=="string").map((v,i)=>{
		return {
			text: v,
			value: Object.values(BrowseExtraButtonLocation)[i+offset] as any as BrowseExtraButtonLocation
		};
	});
}

export class BrowseExtraButton {
	public ID:number = 0;
	public BrowseID:AppBrowse = AppBrowse.CLIENTS;
	public Location:BrowseExtraButtonLocation = BrowseExtraButtonLocation.MENU;
	public Label:string = "";
	public Icon:string = "";
	public Code:string = "";
	public OpenInModal:boolean = false;
	public PaddedModal:boolean = false;
	public Width:number = 0.0;
	public Height:number = 0.0;


	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.BrowseID = data.BrowseID;
		this.Location = data.Location;
		this.Label = data.Label;
		this.Icon = data.Icon;
		this.Code = data.Code;
		this.OpenInModal = data.OpenInModal || false;
		this.PaddedModal = data.PaddedModal || false;
		this.Width = data.Width || 0;
		this.Height = data.Height || 0;
	}

	public getJSON(){
		return {
			ID: this.ID,
			BrowseID: this.BrowseID,
			Location: this.Location,
			Label: this.Label,
			Icon: this.Icon,
			Code: this.Code,
			OpenInModal: this.OpenInModal,
			PaddedModal: this.PaddedModal,
			Width: this.Width,
			Height: this.Height
		};
	}
}